var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance__main-container"},[_c('MaintenanceSvg',{staticClass:"maintenance-svg"}),_c('div',{staticClass:"message"},[_vm._v(" Nothing to preview. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }